import CardBody from 'components/Card/CardBody';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { Divider } from '@material-ui/core';
import CardWrapper from 'components/Card/CardWrapper';
import { useTranslation } from 'react-i18next';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import { makeStyles } from '@material-ui/styles';
import { type Modules } from 'types/modules';
import { type Dispatch, type SetStateAction } from 'react';

type OmnibusSettingsProps = {
  modules: Modules;
  setModules: Dispatch<SetStateAction<Modules>>;
};

const useStyles = makeStyles({
  divider: {
    marginBottom: '20px',
  },
});

const OmnibusSettings = ({ modules, setModules }: OmnibusSettingsProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <CardWrapper title={t('brands.newBrandForm.omnibus')}>
      <CardBody>
        <GridContainer>
          <GridItem md={12}>
            <Divider className={classes.divider} />
            <LabeledCheckbox
              checked={modules.ConfigClientPanel.omnibusEnabledForDefaultPrices}
              onChange={() => {
                setModules(prevState => ({
                  ...prevState,
                  ConfigClientPanel: {
                    ...prevState.ConfigClientPanel,
                    omnibusEnabledForDefaultPrices:
                      !prevState.ConfigClientPanel
                        .omnibusEnabledForDefaultPrices,
                  },
                }));
              }}
              label={t('brands.newBrandForm.omnibus.label')}
            />
          </GridItem>
        </GridContainer>
      </CardBody>
    </CardWrapper>
  );
};

export default OmnibusSettings;
